const mistakes = [
  {
    icon: 'ri-checkbox-circle-line',
    problem: 'Учёба ради галочки',
    desc: '«Мы провели обучение, поставьте галочку в отчёте». Без привязки к бизнес-целям обучение становится формальностью.',
    advice: 'Каждая программа должна решать конкретную бизнес-задачу: рост конверсии, снижение ошибок, ускорение адаптации. Цели обучения формулируются в измеримых показателях.'
  },
  {
    icon: 'ri-search-line',
    problem: 'Нет диагностики',
    desc: 'Обучение начинается без понимания текущего уровня сотрудников. Программа не учитывает реальные потребности.',
    advice: 'Перед стартом — аудит компетенций, анализ KPI, интервью с руководителями. Программа строится на данных, а не на предположениях.'
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    problem: 'Нет оценки результатов',
    desc: 'Единственная метрика — «понравился ли тренинг». Бизнес-результаты не измеряются.',
    advice: 'Внедрить систему оценки: замеры до и после обучения, KPI, конверсия, NPS. Отчёт для руководителя с конкретными цифрами.'
  },
  {
    icon: 'ri-file-copy-2-line',
    problem: 'Нет внедрения',
    desc: 'После тренинга сотрудники возвращаются в привычную среду. Через 2 недели 80% знаний забыто.',
    advice: 'Посттренинговое сопровождение: домашние задания, повторные встречи, закрепление через 2, 4 и 8 недель.'
  },
  {
    icon: 'ri-user-heart-line',
    problem: 'Нет сопровождения',
    desc: 'Обучение заканчивается в последний день тренинга. Никто не проверяет, как знания применяются в работе.',
    advice: 'План сопровождения на 3 месяца после обучения. Чек-поинты, обратная связь, корректировка программы.'
  },
  {
    icon: 'ri-group-line',
    problem: 'Одинаковые программы для всех',
    desc: 'Всех сотрудников учат одному и тому же, независимо от должности, уровня и потребностей.',
    advice: 'Программы адаптируются под группы: продажи, руководители, новички, линейный персонал. У каждой группы — свои задачи.'
  },
  {
    icon: 'ri-book-open-line',
    problem: 'Только теория',
    desc: '80% времени — лекции и презентации. Сотрудники слушают, но не пробуют.',
    advice: 'Формат 20/80: 20% теории, 80% практики. Кейсы из реального бизнеса, ролевые игры, отработка навыков.'
  },
  {
    icon: 'ri-user-unfollow-line',
    problem: 'Нет поддержки руководителей',
    desc: 'Руководители не вовлечены в процесс обучения. Они не знают, чему учат их сотрудников, и не помогают внедрять.',
    advice: 'Руководители получают отчёты и рекомендации: что изменилось, как поддержать сотрудника, какие KPI отслеживать.'
  },
  {
    icon: 'ri-stack-line',
    problem: 'Отсутствует система',
    desc: 'Обучение — это набор случайных тренингов. Нет плана развития, нет последовательности, нет повторения.',
    advice: 'Выстроить систему: диагностика → матрица компетенций → карта обучения → программы → практика → оценка → повторное развитие.'
  },
  {
    icon: 'ri-link-unlink',
    problem: 'Нет связи обучения с KPI',
    desc: 'Обучение живёт отдельно от бизнес-показателей. Никто не знает, как то, чему научили, влияет на результаты.',
    advice: 'Привязать цели обучения к KPI. Конверсия продаж, средний чек, NPS, текучесть — это и есть показатели эффективности обучения.'
  },
];

export default function CompanyMistakes() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Каких ошибок допускают компании при организации обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Большинство проблем с обучением возникает не из-за «плохих сотрудников», а из-за системных ошибок в подходе. Вот 10 самых частых — и что с ними делать.
        </p>

        <div className="space-y-6 max-w-4xl mx-auto">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${m.icon} text-red-600 text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{m.problem}</h3>
                  <p className="text-gray-600 leading-relaxed">{m.desc}</p>
                </div>
              </div>
              <div className="ml-14 bg-teal-50 border border-teal-100 rounded-xl p-4">
                <div className="flex items-start gap-2">
                  <i className="ri-lightbulb-line text-teal-600 mt-0.5"></i>
                  <div>
                    <span className="text-sm font-semibold text-teal-700">Рекомендация: </span>
                    <span className="text-sm text-teal-800">{m.advice}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}